import { useEffect, useMemo } from "react";
import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { ShowAlert, showConfirmationDialog } from "../../utils/functions";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const cols: string[] = ["#", "Option", "Price (£)", "Actions"];

const AddOnOptionListing = observer(() => {
  const { addOnOptstore } = useStores();
  const {
    addOnOptions,
    fetchAddOnOptions,
    setEditAddOnOption,
    deleteAddOnOption,
  } = addOnOptstore;

  useEffect(() => {
    fetchAddOnOptions();
  }, []);

  const addOnOptsList = useMemo(() => {
    return addOnOptions;
  }, [addOnOptions]);

  const handleDelete = (addOnOptId: number) => {
    showConfirmationDialog(() => {
      deleteAddOnOption(addOnOptId, (res: boolean) => {
        if (res) {
          ShowAlert.Success("Add-On Option deleted successfully.");
          fetchAddOnOptions();
        } else ShowAlert.Error("Request failed. Please try again.");
      });
    });
  };

  return (
    <table className="table table-responsive table-striped shadow-lg">
      <thead>
        <tr>
          {cols.map((c, i) => (
            <th
              scope="col"
              className="border-top-0 border-start-0 border-end-0 border-3 border-warning"
              key={i}
            >
              {c}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {addOnOptsList?.map((opt, i) => (
          <tr key={i}>
            <th>{i + 1}</th>
            <td className="text-start">{opt.addOnOptionName}</td>
            <td>£{opt.addOnOptionPrice}</td>
            <td>
              <button className="btn" onClick={() => setEditAddOnOption(opt)}>
                <FontAwesomeIcon icon={faEdit} className="text-primary" />
              </button>
              <button
                className="btn"
                onClick={() => handleDelete(opt.addOnOptionId)}
              >
                <FontAwesomeIcon icon={faTrash} className="text-danger" />
              </button>
            </td>
          </tr>
        ))}
        {!addOnOptsList?.length && (
          <tr>
            <th colSpan={4} className="text-center">
              No data available.
            </th>
          </tr>
        )}
      </tbody>
    </table>
  );
});

export default AddOnOptionListing;
